import * as io from 'io-ts';

export enum PaymentProviders {
  CyberSource = 'CYBERSOURCE',
  VGS = 'VGS',
}

export const CreatePaymentMethodTokenRequest = io.type({
  scopeID: io.string,
  scopeType: io.literal('BUYER'),
  provider: io.union([
    io.literal(PaymentProviders.CyberSource),
    io.literal(PaymentProviders.VGS),
  ]),
  targetOrigins: io.array(io.string),
});

export type CreatePaymentMethodTokenRequest = io.TypeOf<
  typeof CreatePaymentMethodTokenRequest
>;

const CreatePaymentMethodAccessToken = io.type({
  expiresAt: io.string,
  issuedAt: io.string,
  provider: io.union([
    io.literal(PaymentProviders.CyberSource),
    io.literal(PaymentProviders.VGS),
  ]),
  token: io.string,
});
export const CreatePaymentMethodTokenResponse = io.type({
  accessToken: CreatePaymentMethodAccessToken,
});

export type CreatePaymentMethodTokenResponse = io.TypeOf<
  typeof CreatePaymentMethodTokenResponse
>;

export enum PaymentMethodTypes {
  CardAccount = 'CARD_ACCOUNT',
  BankAccount = 'BANK_ACCOUNT',
}

export enum AccountTypes {
  Checking = 'CHECKING',
  Savings = 'SAVINGS',
}

export enum CardType {
  Credit = 'CREDIT',
  Debit = 'DEBIT',
  Unknown = 'UNKNOWN_CARD_TYPE',
}

export const CardAccount = io.partial({
  cardType: io.string,
  cardName: io.string,
  last4: io.string,
  expirationMonth: io.string,
  expMonth: io.string,
  expirationYear: io.string,
  expYear: io.string,
  nonce: io.string,
  provider: io.union([
    io.literal(PaymentProviders.CyberSource),
    io.literal(PaymentProviders.VGS),
  ]),
  disabled: io.boolean,
  postalCode: io.string,
});

export enum BankAccountSetupTypes {
  ACH = 'ACH',
  EFT = 'EFT',
}

export enum BankAccountCountry {
  US = 'US',
  CA = 'CA',
}

export enum BankAccountCurrency {
  USD = 'USD',
  CAD = 'CAD',
}

export type CardAccount = io.TypeOf<typeof CardAccount>;

export const BankAccount = io.partial({
  bankName: io.string,
  accountType: io.string,
  setupType: io.union([
    io.literal(BankAccountSetupTypes.ACH),
    io.literal(BankAccountSetupTypes.EFT),
  ]),
  accountNumber: io.string,
  routingNumber: io.string,
  country: io.union([
    io.literal(BankAccountCountry.US),
    io.literal(BankAccountCountry.CA),
  ]),
  currency: io.union([
    io.literal(BankAccountCurrency.USD),
    io.literal(BankAccountCurrency.CAD),
  ]),
});

export type BankAccount = io.TypeOf<typeof BankAccount>;

export const StoredPaymentMethod = io.intersection([
  io.type({
    id: io.string,
    paymentMethodType: io.string,
    scopeID: io.string,
    scopeType: io.unknown, //only need this attribute to be optional
  }),

  io.partial({
    cardAccount: CardAccount,
    bankAccount: BankAccount,
  }),
]);

export type PaymentMethod = io.TypeOf<typeof StoredPaymentMethod>;

export const PaymentMethodType = io.string;

export type PaymentMethodType = io.TypeOf<typeof PaymentMethodType>;

export const CreatePaymentMethodResponse = io.type({
  paymentMethod: io.intersection([
    StoredPaymentMethod,
    io.type({ name: io.string }),
  ]),
});

export type CreatePaymentMethodResponse = io.TypeOf<
  typeof CreatePaymentMethodResponse
>;

export type PaymentMethodResponse = io.TypeOf<typeof PaymentMethodResponse>;
export const PaymentMethodResponse = io.type({
  paymentMethod: StoredPaymentMethod,
});

export type PaymentMethodsResponse = io.TypeOf<typeof PaymentMethodsResponse>;
export const PaymentMethodsResponse = io.type({
  paymentMethods: io.array(StoredPaymentMethod),
});
